import { PillColor } from '../../../components/pill/Pill';
import { CreditNoteStatus } from 'src/types/enums';

export const CreditNoteStatusToText: Record<CreditNoteStatus, string> = {
  [CreditNoteStatus.Draft]: 'Opmaak',
  [CreditNoteStatus.Created]: 'Aangemaakt',
  [CreditNoteStatus.Sent]: 'Verstuurd',
};

export const CreditNoteStatusToColor: Record<CreditNoteStatus, PillColor> = {
  [CreditNoteStatus.Draft]: 'neutral',
  [CreditNoteStatus.Created]: 'neutral',
  [CreditNoteStatus.Sent]: 'positive',
};
